import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root',
})
export class ReligionService extends CrudService {

  constructor(public override http: HttpClient) {
    super('religion', http);
  }

  /**
   * Check religion field is unique
   * @returns object
   */
  checkUniqueReligion(religionName: string, id: number) {
    return this.http.get(
      `${this.baseUrl}/check-unique-religion/${religionName}/${id}`
    );
  }
}
